module.exports = __webpack_public_path__ + "img/jg04-4866fc.jpg";